import React, { useState } from "react";
import { formatNumber } from "utils/currencyFormat";
import ChiTietHopDong from "../../../../service/chiTietHopDongApi";
import ChiTietHopDongContainer from "containers/Common/QuanLyChoVay/ChiTietHopDongContainer";
import { ModalChiTietHopDong } from "../../../NhanVay/ChiTietHopDong/ModalChiTietHopDong";
export const BtnChiTietHopDong = ({ item }) => {
  const [showChiTietHopDong, setShowChiTietHopDong] = useState(false);
  const handleCloseChiTietHopDong = () => setShowChiTietHopDong(false);
  const handleShowChiTietHopDong = () => setShowChiTietHopDong(true);

  const objChiTietHopDong = {};
  const [chovayChiTiet, setChoVay] = useState(objChiTietHopDong);

  const timkiemHopDong = { choVayId: 0 };

  const functionChiTietChoVay = () => {
    timkiemHopDong.choVayId = item.ChoVayID;
    ChiTietHopDong.getChiTietHopDong1(item.ChoVayID).then((response) => {
      setChoVay(response.data);
      setShowChiTietHopDong(true);
    });
  };

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      {item.CVType === null || item.CVType === 4 ? (
        <>
          <a
            onClick={handleShow}
            href={() => false}
            className="text-cenrte blue btn-link"
          >
            {item.Code}
          </a>
          {show && (
            <ModalChiTietHopDong
              show={show}
              onHide={handleClose}
              nhanvayId={item.NhanVayID}
              item={item}
            />
          )}
        </>
      ) : (
        <>
          <a
            onClick={functionChiTietChoVay}
            href={() => false}
            className="color-xanh-bold  word-break"
          >
            {item.Code}
          </a>
          {showChiTietHopDong && (
            <ChiTietHopDongContainer
              show={handleShowChiTietHopDong}
              onHide={handleCloseChiTietHopDong}
              data={chovayChiTiet}
              setModalTaiSan={handleShowChiTietHopDong}
            ></ChiTietHopDongContainer>
          )}
        </>
      )}
    </>
  );
};
